if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        
        this.form = this.querySelector('form');

        // Listen for variant changes to update bundle SKU (dataLayer) 
        document.addEventListener('variant:change', this.getBundleTrackingData.bind(this));

        if (this.form) {
          const idEl = this.form.querySelector('[name=id]');
          if (idEl) idEl.disabled = false;
          
          // manipulate id name for upsell
          this.form.querySelector('input[name=id].product-variant-id')?.setAttribute('name', 'items[0][id]');
          this.form.querySelector('select[name=id].product-variant-id')?.setAttribute('name', 'items[0][id]');
          
          this.errorWrapper = this.form.querySelector('[js-pdp-form-error] ul');
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        document.addEventListener('selectPDPOptions:change', this.getSelectionOption.bind(this));

        document.addEventListener('nativePropertySelectOptionDrop:init', this.nativeSelectOptionDrop.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }


      // Add this new method at the end of the class (dataLayer)
      
      getBundleTrackingData() {
        if (!window.kalkiBundle || !window.kalkiBundle.product_is_bundle) {
          return null;
        }

        return {
          event: "add_to_cart_bundle",
          product_is_bundle: true,
          bundle_collection: window.kalkiBundle.bundle_collection,
          bundle_id: window.kalkiBundle.bundle_id,
          bundle_name: window.kalkiBundle.bundle_name,

          ecommerce: {
            currency: window.kalkiBundle.currency,
            value: window.kalkiBundle.bundle_price,

            items: [
              {
                item_id: window.kalkiBundle.bundle_id,
                item_name: window.kalkiBundle.bundle_name,
                item_category: "Couple Edit",
                quantity: 1,
                price: window.kalkiBundle.bundle_price
              }
            ]
          }
        };
      }

      pushBundleAddToCartEvent() {
        if (!window.kalkiBundle || !window.kalkiBundle.product_is_bundle) return;

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: "add_to_cart_bundle",
          product_is_bundle: true,
          bundle_collection: window.kalkiBundle.bundle_collection,
          bundle_id: window.kalkiBundle.bundle_id,
          bundle_name: window.kalkiBundle.bundle_name,

          ecommerce: {
            currency: window.kalkiBundle.currency,
            value: window.kalkiBundle.bundle_price,
            items: [
              {
                item_id: window.kalkiBundle.bundle_id,
                item_name: window.kalkiBundle.bundle_name,
                item_category: "Couple Edit",
                quantity: 1,
                price: window.kalkiBundle.bundle_price
              }
            ]
          }
        });

        console.log("add_to_cart_bundle pushed to dataLayer");
      }


      setupCloudflareHandler() {
        // Intercept fetch for cart requests
        const originalFetch = window.fetch;
        
        window.fetch = function(...args) {
          return originalFetch.apply(this, args).then(async response => {
            // Only handle /cart/ requests
            if (!args[0].includes('/cart/')) {
              return response;
            }

            // Check if 429 status (Cloudflare challenge)
            if (response.status === 429) {
              const text = await response.clone().text();
              
              // Check if it's HTML (Cloudflare challenge page)
              if (text.includes('<!DOCTYPE html>') || text.includes('__cf_chl')) {
                
                // Save the current page to return to
                const returnUrl = window.location.href;
                sessionStorage.setItem('return_to_product', returnUrl);
                sessionStorage.setItem('captcha_challenge_detected', 'true');
                
                // Show notification
                showCloudflareNotification('🔒 Security verification required. Redirecting...', 'warning');
                
                // Redirect to trigger challenge on main page
                setTimeout(() => {
                  window.location.href = '/cart';
                }, 500);
                
                return Promise.reject(new Error('Cloudflare challenge - redirecting'));
              }
            }

            return response;
          }).catch(error => {
            console.error('Fetch error:', error);
            throw error;
          });
        }.bind(this);
      }

      nativeSelectOptionDrop({detail}) {
        const context_ = detail

        let optionName = context_.dataset.optionName
        let isRequired = context_.getAttribute('required') != null
        let optionValue= context_.value

        let errAlreadyThere =  this.errorWrapper?.querySelector(`li[data-option-name="${optionName}"]`)
        if(errAlreadyThere && optionValue) {
          this.errorWrapper.removeChild(errAlreadyThere)
        }

        if(this.errorWrapper) {
          this.errorWrapper.style.display = 'none';
          if(this.errorWrapper?.childElementCount) {
            this.errorWrapper.style.display = 'block';
          }
        }
        
      }

      getSelectionOption({ detail }) {
        const context_ = detail.context

        let optionName = context_.dataset.optionName
        let isRequired = context_.getAttribute('required') != null
        let optionValue= context_.value

        let errAlreadyThere =  this.errorWrapper.querySelector(`li[data-option-name="${optionName}"]`)
        if(errAlreadyThere && optionValue) {
          this.errorWrapper.removeChild(errAlreadyThere)
        }
        if(this.errorWrapper) {
          this.errorWrapper.style.display = 'none';
        }
        if(this.errorWrapper?.childElementCount) {
          this.errorWrapper.style.display = 'block';
        }

      }

      formValidation() {
        this.errorWrapper.style.display = 'none';
        let requiredOptionSelects = this.form.querySelectorAll('[js-custom-option-select][required]')

        if(requiredOptionSelects) {
          requiredOptionSelects.forEach(el => {
            const optionName = el?.dataset.optionName
            let errAlreadyThere =  this.errorWrapper?.querySelector(`li[data-option-name="${optionName}"]`)
            if(el.value == '' && !errAlreadyThere) {
              let newError = document.createElement('li')
              newError.setAttribute('data-option-name', optionName)
              newError.textContent = `Please select ${optionName}`;
              this.errorWrapper?.appendChild(newError)
            }
          })
        }
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        const twiningProduct = this.form.querySelector('.twining-tab-warp');
        if (twiningProduct) {
          const requiredFields = this.form.querySelectorAll("[data-original-required='true']");
          for (const el of requiredFields) {
            if (el.value.trim() === "") {
              return;
            }
          }
          const product1Input = this.form.querySelector('input[name="Size-Product1"]:checked');
          const product2Input = this.form.querySelector('input[name="Size-Product2"]:checked');
          if (!product1Input) { return; }
          if (!product2Input) { return; }
        }
  //saving % get main product and set cart page
          // let savingValue = document.querySelector(".data-saving-pdp")?.getAttribute("data-saving");
          // let inputField = document.querySelector("#savingPrices"); // Select the input field

          // if (savingValue && inputField) {
          //     inputField.value = savingValue; // Set the value of the input field
          //     inputField.removeAttribute('disabled');
          // } else {
          //     inputField.setAttribute('disabled', '');
          // }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage();
      
        // Start showing loader immediately
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
      
        // Generate the refTimeStamp before adding any products
        const refTimeStamp = Date.now(); // Shared timestamp for both main and upsell products
      
        // First check for upsell products
        const upsellProducts = this.form.querySelectorAll('[js-upsell-product] input:checked');
        if (upsellProducts.length > 0) {
          // If there are upsell products, add them first
          this.addUpsellProducts(refTimeStamp)
            .then(() => {
              console.log('Upsell products added. Now adding main product.');
              return this.addMainProduct(refTimeStamp); // After upsell, add the main product with the same refTimeStamp
            })
            .catch((error) => {
              console.error('Error adding upsell products:', error);
            })
            .finally(() => {
              this.hideLoader(); // Hide loader after both upsell and main product are added
            });
        } else {
          // If no upsell products, directly add the main product
          this.addMainProduct(refTimeStamp)
            .finally(() => {
              this.hideLoader(); // Hide loader after adding the main product
            });
        }
      }
      
      hideLoader() {
        // Hide loader and reset submit button state
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }
      
      // Add upsell products before the main product
      addUpsellProducts(refTimeStamp) {
        return new Promise((resolve, reject) => {
          const upsellProducts = this.form.querySelectorAll('[js-upsell-product] input:checked');
          
          if (upsellProducts.length > 0) {
            let upsellFormData = new FormData();
      
            // Loop through upsell products and add them to the formData
            upsellProducts.forEach((elm, index_) => {
              if (elm.dataset.productId) {
                upsellFormData.append(`items[${index_}][id]`, Number(elm.dataset.productId));
                upsellFormData.append(`items[${index_}][quantity]`, 1);
                upsellFormData.append(`items[${index_}][properties][_ref_id]`, refTimeStamp); // Append the same refTimeStamp
                upsellFormData.append(`items[${index_}][properties][_type]`, 'sub product');
              }
            });
            window.upsellRefTimeStamp = refTimeStamp
            const upsellConfig = fetchConfig('javascript');
            upsellConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete upsellConfig.headers['Content-Type'];
            upsellConfig.body = upsellFormData;
      
            fetch(`${routes.cart_add_url}`, upsellConfig)
              .then((response) => response.json())
              .then((response) => {
                if (!response.status) {
                  console.log('Upsell products added to cart successfully');
                  resolve(); // Resolve when upsell products are added
                } else {
                  console.error('Failed to add upsell products');
                  reject('Failed to add upsell products');
                }
              })
              .catch((e) => {
                console.error('Error adding upsell products:', e);
                reject(e);
              });
          } else {
            console.log('No upsell products selected.');
            resolve(); // Resolve if no upsell products are selected
          }
        });
      }
      
      // Add main product after upsell products (or directly if no upsell)
      addMainProduct(refTimeStamp) {
        return new Promise((resolve, reject) => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
      
          const formData = new FormData(this.form);
          console.log('Adding main product to cart');
          this.setupCloudflareHandler();
      
          // Append the same refTimeStamp to the main product
          if (this.form.querySelectorAll('[js-upsell-product] input:checked').length > 0) {
            formData.append('items[0][properties][_ref_id]', refTimeStamp);
            formData.append('items[0][properties][_with_upsell]', 'Yes');
          }
      
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
      
          config.body = formData;
      
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('items[0][id]'), // Handle errors correctly
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
      
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                reject('Main product sold out');
              } else {
                if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
      
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
      
                const quickAddModal = this.closest('quick-add-modal');
                const shirtPdpPopup = this.closest('[js-shirt-pdp-popup]');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                        if (typeof updateCartEstimatedDelivery === 'function') {
                          updateCartEstimatedDelivery();
                        }
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                  if (typeof updateCartEstimatedDelivery === 'function') {
                    updateCartEstimatedDelivery();
                  }
                  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (shirtPdpPopup) {
                    shirtPdpPopup.dispatchEvent(new CustomEvent('shirt-pdp-popup:close', { bubbles: true }));
                  }
                }

                const customizePopup = document.getElementById('size-customize-popup');
                const customizeBody = document.body;
                if (customizePopup && customizePopup.classList.contains("customize-popup-open")) {
                  customizePopup.classList.remove("customize-popup-open");
                  customizeBody.classList.remove("customize-open");
                }
      
                resolve(); // Main product added successfully
              }
            })
            .catch((e) => {
              console.error(e); // Handle errors
              reject(e);
            });
        });
      }



      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.setAttribute('tabindex', '-1');
          const buyNowButtons = document.querySelectorAll("button[type=\"button\"].shopify-payment-button__button.shopify-payment-button__button--unbranded");

          setTimeout(() => {
            requestAnimationFrame(() => {
              this.errorMessageWrapper.focus();
              buyNowButtons?.forEach((button) => {
                  button?.removeAttribute('disabled');
              });
            });
          }, 200);
          this.hideLoader();
        }
      }
    }
  );
}


// Handle cart page redirect after CAPTCHA
function handleCartPageAfterCaptcha() {
  const returnUrl = sessionStorage.getItem('return_to_product');
  const captchaDetected = sessionStorage.getItem('captcha_challenge_detected');
  
  if (!returnUrl || !captchaDetected) {
    return;
  }
  
  if (window.location.pathname !== '/cart') {
    return;
  }
  
  // Show message and button to user
  showCartMessage(returnUrl);
}

function showCartMessage(returnUrl) {
  // Create overlay with message and button
  const container = document.createElement('div');
  container.setAttribute('data-captcha-handler', 'true');
  container.style.cssText = `position: fixed;bottom: 30px;right: 30px;background: white;border: 2px solid #28a745;border-radius: 8px;padding: 20px;max-width: 350px;z-index: 99999;box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;  `;
  
  // Title
  const title = document.createElement('h3');
  title.textContent = '✅ Ready to Continue';
  title.style.cssText = `margin: 0 0 10px 0;font-size: 16px;color: #28a745;font-weight: 600;  `;
  container.appendChild(title);
  
  // Message
  const message = document.createElement('p');
  message.textContent = 'Security verification complete. Click below to return and add the product to your cart.';
  message.style.cssText = `margin: 0 0 15px 0;font-size: 14px;color: #333;line-height: 1.5;  `;
  container.appendChild(message);
  
  // Button
  const button = document.createElement('button');
  button.textContent = '← Return to Product';
  button.style.cssText = `width: 100%;padding: 12px 16px;background: #28a745;color: white;border: none;border-radius: 6px;font-size: 14px;font-weight: 600;cursor: pointer;transition: all 0.3s;  `;
  
  button.onmouseover = () => {
    button.style.background = '#218838';
    button.style.transform = 'translateY(-2px)';
    button.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
  };
  
  button.onmouseout = () => {
    button.style.background = '#28a745';
    button.style.transform = 'translateY(0)';
  };
  
  button.onclick = () => {
    // Clear the saved data
    sessionStorage.removeItem('return_to_product');
    sessionStorage.removeItem('captcha_challenge_detected');
    
    // Show success message and redirect
    showCloudflareNotification('✅ Verification complete! Redirecting...', 'success');
    
    setTimeout(() => {
      window.location.href = returnUrl;
    }, 1000);
  };
  
  container.appendChild(button);
  document.body.appendChild(container);
}

// Helper function to show notifications
function showCloudflareNotification(message, type = 'info') {
  const oldNotif = document.querySelector('[data-cloudflare-notification]');
  if (oldNotif) oldNotif.remove();
  
  const notification = document.createElement('div');
  notification.setAttribute('data-cloudflare-notification', 'true');
  notification.style.cssText = `position: fixed;top: 20px;right: 20px;padding: 15px 20px;border-radius: 6px;z-index: 99998;font-size: 14px;font-weight: 500;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);max-width: 350px;word-wrap: break-word;  `;
  
  if (type === 'warning') {
    notification.style.background = '#fff3cd';
    notification.style.color = '#856404';
    notification.style.border = '1px solid #ffc107';
  } else if (type === 'success') {
    notification.style.background = '#d4edda';
    notification.style.color = '#155724';
    notification.style.border = '1px solid #28a745';
  }
  
  notification.textContent = message;
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.style.transition = 'opacity 0.3s ease';
    notification.style.opacity = '0';
    setTimeout(() => notification.remove(), 300);
  }, 5000);
}

// Run on page load to check for CAPTCHA completion
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(handleCartPageAfterCaptcha, 1000);
  });
} else {
  handleCartPageAfterCaptcha();
}

// Also check when page visibility changes
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    setTimeout(handleCartPageAfterCaptcha, 500);
  }
});